import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sample-print',
  templateUrl: './sample-print.component.html',
  styleUrls: ['./sample-print.component.scss']
})
export class SamplePrintComponent {

  @Input() imageUrl: any;
  @Input() iconUrl: any;
  @Input() title: any;
  @Input() date: any;
  @Input() modelDate: string = 'd MMMM yyyy';
  @Input() subtitle: any;
  @Input() taxonomy: any;
  @Input() taxonomies: any;
  @Input() taxonomies2: any;
  @Input() description: any;

}
